import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@environments/environment';
import { merge } from 'lodash';

async function loadConfig() {
	if (environment['FF_CONFIG_ENABLED']) {
		return fetch('/assets/config.json')
			.then((response) => response.json())
			.then((config) => {
				const mergedConfig = merge(environment, config);
				mergedConfig.menuItems = config.menuItems;
				return mergedConfig;
			});
	}

	return Promise.resolve();
}

loadConfig()
	.then(() => {
		if (environment.production) {
			enableProdMode();
		}
		return import('./app/app.module');
	})
	.then((AppModule: any) => {
		return platformBrowserDynamic().bootstrapModule(AppModule.AppModule);
	})
	.catch((err) => {
		// eslint-disable-next-line no-console
		console.error(err);
	});
